import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Stack,
  Flex,
  DrawerCloseButton,
  Text,
  Icon,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  BsArrowRight,
  BsBagCheckFill,
  BsChevronCompactRight,
} from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { FaCreditCard, FaBookOpen, FaEnvelope } from "react-icons/fa";
import { ImEnter, ImExit } from "react-icons/im";
import { MdOutlineAssignment, MdOutlineFeedback } from "react-icons/md";
import EmailNotificationsModal from "./Modals/emailNotificationsModal";
import FeedbackModal from "./Modals/feedbackModal";
import { FormsDrawer } from "./FormsDrawer";
import { isPropertyOnly } from "../../Helper/propertyLink";

const MenuItem = ({ icon, title, func, isDisabled }) => (
  <Box
    as={Flex}
    align="center"
    justify="space-between"
    py={4}
    px={3}
    onClick={!isDisabled ? func : undefined}
    opacity={isDisabled ? 0.5 : 1}
  >
    <Flex align="center">
      <Icon as={icon} color="white" boxSize={6} />
      <Text ml={4} fontSize={"14px"}>
        {title}
      </Text>
    </Flex>
    <Icon as={BsChevronCompactRight} color="white" boxSize={4} />
  </Box>
);

export const MenuDisplay = ({ onClose, isOpen, aboutOpen, room, booking, accessTimes, manager, onFormsOpenChange }) => {
  const navigate = useNavigate();
  const [isCheckInAvailable, setIsCheckInAvailable] = useState(true);
  const [viewCheckIn, setCheckIn] = useState(true);
  const [viewCheckOut, setCheckOut] = useState(true);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isFormsOpen, setIsFormsOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const propertyOnly = isPropertyOnly(booking);

  const calculateTimeToCheckIn = () => {
    const effectiveCheckInTime =
      accessTimes?.effectiveCheckInTime || room?.checkInTime;

    if (
      room &&
      room.checkInSchedule &&
      booking &&
      booking.checkInDate &&
      effectiveCheckInTime
    ) {
      const schedule = JSON.parse(room.checkInSchedule);
      const checkInDateTime = new Date(
        `${booking.checkInDate}T${effectiveCheckInTime}`
      );
      const scheduledTime = new Date(
        checkInDateTime.getTime() -
          schedule.time * (schedule.unit === "days" ? 24 : 1) * 60 * 60 * 1000
      );

      setIsCheckInAvailable(scheduledTime <= new Date());
    }
  };

  useEffect(() => {
    if (isOpen) {
      if (room && (!room.checkOut || room.checkOut.length === 0)) {
        setCheckOut(false);
      }

      if (room && (!room.checkIn || room.checkIn.length === 0)) {
        setCheckIn(false);
      }
    }

    calculateTimeToCheckIn();
  }, [room, booking, isOpen, accessTimes]);

  const handleCheckIn = () => {
    const type = "checkIn";
    navigate("/steps", {
      state: { room, booking, type, accessTimes, manager },
    });
  };

  const handleCheckOut = () => {
    const type = "checkOut";
    navigate("/steps", {
      state: { room, booking, type, accessTimes, manager },
    });
  };

  const handlePayments = () => {
    navigate("/payments", {
      state: { room, booking },
    });
  };

  const handleEmailUpdate = () => {
    onClose(); // Close the menu first
    setIsEmailModalOpen(true);
  };

  const handleOpenForms = () => {
    onClose();
    setIsFormsOpen(true);
    onFormsOpenChange?.(true);
  };

  const handleCloseForms = () => {
    setIsFormsOpen(false);
    onFormsOpenChange?.(false);
  };

  return (
    <>
      <Drawer placement={"right"} onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <Flex
            mx={3}
            my={4}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Text mr={4} fontSize={"18px"} fontWeight={800}>
              Menu
            </Text>

            <DrawerCloseButton pos={"relative"} top={0} right={0} />
          </Flex>

          <DrawerBody px={0}>
            <Stack spacing="5px">
              {/* <MenuItem title="Services" icon={BsBagCheckFill} /> */}

              {viewCheckIn && (
                <MenuItem
                  title="Check In Instructions"
                  icon={ImEnter}
                  func={handleCheckIn}
                  isDisabled={!isCheckInAvailable}
                />
              )}

              {viewCheckOut && (
                <MenuItem
                  title="Check Out Instructions"
                  icon={ImExit}
                  func={handleCheckOut}
                />
              )}

              {!propertyOnly && (
                <>
                  <MenuItem
                    title="Forms"
                    icon={MdOutlineAssignment}
                    func={handleOpenForms}
                  />

                  <MenuItem
                    title="Update Email"
                    icon={FaEnvelope}
                    func={handleEmailUpdate}
                  />

                  <MenuItem
                    title="Payments"
                    icon={FaCreditCard}
                    func={handlePayments}
                  />
                </>
              )}

              {propertyOnly && (
                <MenuItem
                  title="Send Feedback"
                  icon={MdOutlineFeedback}
                  func={() => {
                    onClose();
                    setIsFeedbackOpen(true);
                  }}
                />
              )}

              <MenuItem
                title="Info & Guides"
                icon={FaBookOpen}
                func={() => {
                  onClose();
                  aboutOpen();
                }}
              />
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <EmailNotificationsModal
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        guestId={booking?.guestID}
        bookingId={booking?.id}
      />

      <FeedbackModal
        isOpen={isFeedbackOpen}
        onClose={() => setIsFeedbackOpen(false)}
        roomId={booking?.roomID || room?.id}
      />

      <FormsDrawer
        isOpen={isFormsOpen}
        onClose={handleCloseForms}
        bookingId={booking?.id}
        guestId={booking?.guestID}
        roomId={booking?.roomID || room?.id}
      />
    </>
  );
};
